var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-form-cell",class:{
    'has-child': _vm.formModel.rules.label
  },style:(_vm.formModel.rules.style)},[(_vm.formModel.rules.label)?_c('span',{staticClass:"v-form-cell__label"},[_c('span',{staticClass:"vertical-middle"},[_vm._v(_vm._s(_vm.formModel.rules.label))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }